// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.nveol0tP018upc7ZkP3n {
	display: flex;
	flex-direction: column;
}

.r9ae0JBC9n3JmmbFlD9z {
	background: var(--white);
	border-radius: 4px;
	box-shadow: inset 0px -1px 1px rgba(0, 0, 0, 0.07);
	height: 8px;
	margin-bottom: 12px;
	overflow: hidden;
	display: flex;
}

.baO8XIUdrdqzc8ONHwEi {
	align-items: center;
	display: flex;
	justify-content: space-between;
}

.aBHJjhP3uofA9gau2ePt {
	height: 25px;
	position: relative;
	width: 25px;
}

.PxFpD_m77TGs8boDRh3w {
	color: var(--black);
	font-size: 16px;
	letter-spacing: -0.08em;
	line-height: 24px;
	position: absolute;
}

.h0Ma_NT4MZK7lfMh0OEG {
	border-radius: 0px 2px 2px 0px;
	height: 100%;
}

.X9GWeQqYBAaabbcwTJHw {
	background-color: var(--black);
}

.HQY3CaDwZANhPb4FgHBF {
	background-color: var(--brand);
}
`, "",{"version":3,"sources":["webpack://./src/components/Progress/Progress.pcss"],"names":[],"mappings":"AAAA;CACC,aAAa;CACb,sBAAsB;AACvB;;AAEA;CACC,wBAAwB;CACxB,kBAAkB;CAClB,kDAAkD;CAClD,WAAW;CACX,mBAAmB;CACnB,gBAAgB;CAChB,aAAa;AACd;;AAEA;CACC,mBAAmB;CACnB,aAAa;CACb,8BAA8B;AAC/B;;AAEA;CACC,YAAY;CACZ,kBAAkB;CAClB,WAAW;AACZ;;AAEA;CACC,mBAAmB;CACnB,eAAe;CACf,uBAAuB;CACvB,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,8BAA8B;CAC9B,YAAY;AACb;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B","sourcesContent":[".container {\n\tdisplay: flex;\n\tflex-direction: column;\n}\n\n.progress {\n\tbackground: var(--white);\n\tborder-radius: 4px;\n\tbox-shadow: inset 0px -1px 1px rgba(0, 0, 0, 0.07);\n\theight: 8px;\n\tmargin-bottom: 12px;\n\toverflow: hidden;\n\tdisplay: flex;\n}\n\n.steps {\n\talign-items: center;\n\tdisplay: flex;\n\tjustify-content: space-between;\n}\n\n.step {\n\theight: 25px;\n\tposition: relative;\n\twidth: 25px;\n}\n\n.stepValue {\n\tcolor: var(--black);\n\tfont-size: 16px;\n\tletter-spacing: -0.08em;\n\tline-height: 24px;\n\tposition: absolute;\n}\n\n.value {\n\tborder-radius: 0px 2px 2px 0px;\n\theight: 100%;\n}\n\n.current {\n\tbackground-color: var(--black);\n}\n\n.increase {\n\tbackground-color: var(--brand);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `nveol0tP018upc7ZkP3n`,
	"progress": `r9ae0JBC9n3JmmbFlD9z`,
	"steps": `baO8XIUdrdqzc8ONHwEi`,
	"step": `aBHJjhP3uofA9gau2ePt`,
	"stepValue": `PxFpD_m77TGs8boDRh3w`,
	"value": `h0Ma_NT4MZK7lfMh0OEG`,
	"current": `X9GWeQqYBAaabbcwTJHw`,
	"increase": `HQY3CaDwZANhPb4FgHBF`
};
export default ___CSS_LOADER_EXPORT___;
